import React from "react";

const Container = (props) => {
  return <div className="px-4 flex-1 overflow-hidden flex flex-col" >{props?.children}</div>;
};

export default Container;
